import {pushFBEvent, pushGoogleTag} from './common';


export const PLANS = {
// fullPrice
    'fm-6month-71.76': {
        name: 'fm-6month-71.76',
        price: 71.76,
        periodPrice: 71.76,
        description: 'semi_annually',
        disclaimer: 'semi_annually',
        productId: '6 months - $71.76',
        duration: '6 months',
    },
    'fm-3month-59.99': {
        name: 'fm-3month-59.99',
        price: 59.99,
        periodPrice: 59.99,
        description: 'quarterly',
        disclaimer: 'quarterly',
        productId: '3 months - $59.99',
        duration: '3 months',
    },
    'fm-monthly-39.99': {
        name: 'fm-monthly-39.99',
        price: 39.99,
        periodPrice: 39.99,
        description: 'monthly',
        disclaimer: 'monthly',
        productId: '1 month - $39.99',
        duration: '1 month',
    },
    'fm-monthly-intro7d-6.99-39.99': {
        name: 'fm-monthly-intro7d-6.99-39.99',
        price: 39.99,
        periodPrice: 6.99,
        description: 'one month',
        disclaimer: 'monthly',
        productId: '1 month - $39.99',
        duration: '1 month',
    },
    

    // upsell plans
    'fm-monthly-upsell-599': {
        name: 'fm-monthly-upsell-599',
        price: 5.99,
        periodPrice: 5.99,
        description: 'monthly upsell',
        productId: '1 month - upsell $5.99',
        duration: '1 month',
    },
    'fm-monthly-upsell-799': {
        name: 'fm-monthly-upsell-799',
        price: 7.99,
        periodPrice: 7.99,
        description: 'monthly upsell',
        productId: '1 month - upsell $7.99',
        duration: '1 month',
    },
    'fm-monthly-upsell-999': {
        name: 'fm-monthly-upsell-999',
        price: 9.99,
        periodPrice: 9.99,
        description: 'monthly upsell',
        productId: '1 month - upsell $9.99',
        duration: '1 month',
    },
    'fm-3month-upsell-599': {
        name: 'fm-3month-upsell-599',
        price: 5.99,
        periodPrice: 5.99,
        description: '3 month upsell',
        productId: '3 month - upsell $5.99',
        duration: '3 month',
    },
    'fm-3month-upsell-799': {
        name: 'fm-3month-upsell-799',
        price: 7.99,
        periodPrice: 7.99,
        description: '3 month upsell',
        productId: '3 month - upsell $7.99',
        duration: '3 month',
    },
    'fm-3month-upsell-999': {
        name: 'fm-3month-upsell-999',
        price: 9.99,
        periodPrice: 9.99,
        description: '3 month upsell',
        productId: '3 month - upsell $9.99',
        duration: '3 month',
    },
    'fm-6month-upsell-599': {
        name: 'fm-6month-upsell-599',
        price: 5.99,
        periodPrice: 5.99,
        description: '6 month upsell',
        productId: '6 month - upsell $5.99',
        duration: '6 month',
    },
    'fm-6month-upsell-799': {
        name: 'fm-6month-upsell-799',
        price: 7.99,
        periodPrice: 7.99,
        description: '6 month upsell',
        productId: '6 month - upsell $7.99',
        duration: '6 month',
    },
    'fm-6month-upsell-999': {
        name: 'fm-6month-upsell-999',
        price: 9.99,
        periodPrice: 9.99,
        description: '6 month upsell',
        productId: '6 month - upsell $9.99',
        duration: '6 month',
    },
};

const UPSELL = {
    name: 'fm-monthly-upsell-std',
    price: 9.99,
    quantity: 1
};

export const setMetrics = (plan, id, isUpsell = false, referer = '', eventId) => {
    const price = PLANS[plan].price;
    const upsellPrice = UPSELL.price;

    const items = isUpsell
        ? [
            {
                item_name: UPSELL.name,
                item_id: UPSELL.name,
                item_price: upsellPrice,
                quantity: 1,
                item_coupon: ''
            }
        ]
        : [
            {
                item_name: PLANS[plan].name,
                item_id: PLANS[plan].name,
                item_price: price,
                quantity: 1,
                item_coupon: ''
            }
        ];

    const gaData = {
        transaction_id: id,
        affiliation: 'Onboarding Store',
        value: isUpsell ? upsellPrice : price,
        tax: 0,
        shipping: 0,
        currency: 'USD',
        coupon: '',
        items
    };

    const setFbData = type => {
        return {
            value: type === 'upsell' ? upsellPrice : price,
            currency: 'USD',
            content_type: type,
            content_name: referer,
            subscription_sid: id,
        }
    };

    const fbData = setFbData('paid_subscription');
    const upsellFbData = setFbData('upsell');

    pushFBEvent(fbData,eventId);
    pushGoogleTag('purchase',gaData);
    if (isUpsell) pushFBEvent(upsellFbData,`${eventId}_upsell`);
};